export default __webpack_public_path__ + "static/media/end_date.9f69bd88.svg";